import { SendFindPasswordLinkByEmailPayload } from "@/data/payload/auth/send-find-password-link-by-email-payload";
import { UserPasswordManageRepository } from "@/domain/repository/user-password-reset-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class SendEmailIncludePasswordResetLinkUsecase {
  //MARK:- init
  constructor(private readonly userPasswordManageRepository: UserPasswordManageRepository) {}

  //MARK:- execute
  async execute(email: string): Promise<SATResult<void, SATError>> {
    const payload: SendFindPasswordLinkByEmailPayload = {
      email: email,
    };

    const result = await this.userPasswordManageRepository.sendEmailIncludePasswordResetLink(
      payload
    );

    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return SATResult.success(void 0);
  }
}
